

































/**
 * tmp remove from SharePanel
 *
 * <a class="share-item" :href="`https://www.facebook.com/sharer.php?u=${shareLink}`"
 *                        @click.prevent.stop="openWindow(`https://www.facebook.com/sharer.php?u=${shareLink}`, 'newwindow', 'width=650,height=570')"
 *                        target="_blank">
 *                         <FacebookIcon width="50px" height="50px"/>
 *                         <span class="share-item-title">Facebook</span></a>
 *                     <a class="share-item" :href="`https://twitter.com/share?url=${shareLink}`"
 *                        @click.prevent.stop="openWindow(`https://twitter.com/share?url=${shareLink}`, 'newwindow', 'width=650,height=570')"
 *                        target="_blank">
 *                         <TwitterIcon width="50px" height="50px"/>
 *                         <span class="share-item-title">Twitter</span></a>
 *                     <a class="share-item" :href="`https://www.linkedin.com/sharing/share-offsite/?url=${shareLink}`"
 *                        @click.prevent.stop="openWindow(`https://www.linkedin.com/sharing/share-offsite/?url=${shareLink}`, 'newwindow', 'width=650,height=570')"
 *                        target="_blank">
 *                         <LinkedInIcon width="50px" height="50px"/>
 *                         <span class="share-item-title">LinkedIn</span></a>
 */


import {Component, Vue, Watch, Prop} from "vue-property-decorator";
import FacebookIcon from "~/stories_widget/components/svg/FacebookIcon.vue";
import TwitterIcon from "~/stories_widget/components/svg/TwitterIcon.vue";
import LinkedInIcon from "~/stories_widget/components/svg/LinkedInIcon.vue";
import VkIcon from "~/stories_widget/components/svg/VkIcon.vue";
import CopyIcon from "~/stories_widget/components/svg/CopyIcon.vue";
import {addOnceEventListener} from "~/stories_widget/util/event";

const Clipboard = require('~/stories_widget/helpers/clipboard');


@Component({
    name: "SharePanel",
    components: {CopyIcon, VkIcon, LinkedInIcon, TwitterIcon, FacebookIcon},
})
export default class SharePanel extends Vue {
    @Prop({type: Boolean}) value!: boolean;
    @Prop({type: String}) shareLink!: string;

    get shareUrlDomain() {
        try {
            const shareUrl: URL = new URL(this.shareLink);
            return shareUrl.host;
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    onCopyClick() {
        Clipboard.copy(this.shareLink);
        this.cb = () => {
            this.$emit('shareComplete', true);
        }
        this.closeHandler();
    }

    openWindow(url?: string, target?: string, features?: string) {
        addOnceEventListener(window, 'focus', this.focusCb);
        window.open(url, target, features);
    }
    showPanel = false;
    showContent = false;
    cb = () => {};
    closePanel() {
        this.showPanel = false;
        this.$emit('input', false);
        this.cb();
    }
    closeHandler() {
        this.showContent = false;
    }
    focusCb() {
        this.closeHandler();
        this.cb = () => {
            this.$emit('shareComplete', true);
        };
    }
    @Watch('value')
    onChangeValue(val: boolean) {
        if (val) {
            this.showPanel = this.showContent = true;
            this.$nextTick(() => this.updatePanelHeight());
        } else {
            this.closeHandler();
        }
    }

    onBackdropClick() {
        this.cb = () => {
            this.$emit('shareComplete', false);
        }
        this.closeHandler();
    }

    panelHeight: string = '100%';
    updatePanelHeight() {
        if (this.$refs.sharePanel) {
            this.panelHeight = window.getComputedStyle((<any>this.$refs.sharePanel)).height;
        }
    }

}

